/* eslint-disable indent */
import { Collapse, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import React, { FunctionComponent, useState } from 'react';
import { useHistory } from 'react-router-dom';
import AdminScreenPathsList from '../../../../Datas/BeecomingDatas/AdminScreenPathsList';
import AdminScreen from '../../../../Types/BeecomingTypes/AdminScreen';
import NavigationItem, { NavigationSubItem } from '../../../../Types/BeecomingTypes/NavigationItem';
import NavigationSubItemComponent from './NavigationSubItemComponent';

const NavigationItemComponent: FunctionComponent<NavigationItem> = ({ label, node, imgSrc }) => {
  const history = useHistory();
  const [open, setOpen] = useState(true);
  const handleClick = () => setOpen(!open);
  const path = AdminScreenPathsList[node as AdminScreen];
  const subItems = path === undefined ? (node as NavigationSubItem[]) : undefined;

  return (
    <div>
      <ListItem
        button
        component="a"
        onClick={
          path !== undefined
            ? () => {
                if (path !== undefined) {
                  history.push(path as string);
                }
              }
            : handleClick
        }
      >
        <ListItemIcon>
          <img src={imgSrc as string} alt="" className="sidebarLogo" />
        </ListItemIcon>

        <ListItemText primary={label} />
        {subItems !== undefined ? <>{open ? <ExpandLess /> : <ExpandMore />}</> : null}
      </ListItem>
      {subItems !== undefined ? (
        <Collapse in={open}>
          <List component="ul" disablePadding>
            {subItems.map((item) => (
              <NavigationSubItemComponent key={item.label} label={item.label} to={item.to} />
            ))}
          </List>
        </Collapse>
      ) : null}
    </div>
  );
};

export default NavigationItemComponent;
